import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'ul[data-component-type=options]',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsComponent implements OnInit {

  @Input() options!: OptionSetting[]
  @Output() valueChanges: EventEmitter<any> = new EventEmitter()

  @HostListener('mousedown', ['$event']) emitValue(event: MouseEvent) {
    const target = event.target as HTMLLIElement
    if (target !== this.el.nativeElement) this.valueChanges.emit(this.options.find(value => value.text === target.textContent))
  }

  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
  }

  trackByFn(index: number, item: OptionSetting) {
    return item.text
  }

}

export type OptionSetting = {text: string, value: any, presence: boolean}
